var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranstelekom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 123.191 35.768",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "transtelekom_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d92b22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3493c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "transtelekom_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 87.328,
    x2: 87.328,
    xlinkHref: "#transtelekom_svg__a",
    y1: 35.823,
    y2: 0.026
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "transtelekom_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 55.725,
    x2: 55.75,
    xlinkHref: "#transtelekom_svg__a",
    y1: 35.505,
    y2: 0.13
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "transtelekom_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    x2: 17.5,
    xlinkHref: "#transtelekom_svg__a",
    y1: 35.83,
    y2: 0.005
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "transtelekom_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 106.07,
    x2: 106.07,
    xlinkHref: "#transtelekom_svg__a",
    y1: 35.919,
    y2: 0.21
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 14.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.76 7.25H0M17.88 0v35.76",
    stroke: "url(#transtelekom_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.36 7.25H39.6M57.48 0v35.76",
    stroke: "url(#transtelekom_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.38 0v35.76",
    stroke: "url(#transtelekom_svg__d)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.98.008L94.51 13.51h-2.088l-.088 7.16h2.176l11.47 15.09 16.77.008-14.77-18.988L123.19.008z",
    fill: "url(#transtelekom_svg__e)",
    fillRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjM1Ljc2OCIgdmlld0JveD0iMCAwIDEyMy4xOTE0OSAzNS43Njc3OTkiIHdpZHRoPSIxMjMuMTkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxsaW5lYXJHcmFkaWVudCBpZD0iYSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZDkyYjIyIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZjM0OTNjIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iODcuMzI4IiB4Mj0iODcuMzI4IiB4bGluazpocmVmPSIjYSIgeTE9IjM1LjgyMyIgeTI9Ii4wMjU1NTMiLz48bGluZWFyR3JhZGllbnQgaWQ9ImMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iNTUuNzI1IiB4Mj0iNTUuNzUiIHhsaW5rOmhyZWY9IiNhIiB5MT0iMzUuNTA1IiB5Mj0iLjEzIi8+PGxpbmVhckdyYWRpZW50IGlkPSJkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjE3LjUiIHgyPSIxNy41IiB4bGluazpocmVmPSIjYSIgeTE9IjM1LjgzIiB5Mj0iLjAwNDk5OSIvPjxsaW5lYXJHcmFkaWVudCBpZD0iZSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIxMDYuMDciIHgyPSIxMDYuMDciIHhsaW5rOmhyZWY9IiNhIiB5MT0iMzUuOTE5IiB5Mj0iLjIxMDEzIi8+PGcgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxNC41Ij48cGF0aCBkPSJtMzUuNzYgNy4yNWgtMzUuNzZtMTcuODgtNy4yNXYzNS43NiIgc3Ryb2tlPSJ1cmwoI2QpIi8+PHBhdGggZD0ibTc1LjM2IDcuMjVoLTM1Ljc2bTE3Ljg4LTcuMjV2MzUuNzYiIHN0cm9rZT0idXJsKCNjKSIvPjxwYXRoIGQ9Im04Ni4zOCAwdjM1Ljc2IiBzdHJva2U9InVybCgjYikiLz48L2c+PHBhdGggZD0ibTEwNS45OC4wMDc4MTItMTEuNDcgMTMuNTAyaC0yLjA4NzlsLS4wODg0IDcuMTZoMi4xNzYzbDExLjQ3IDE1LjA5IDE2Ljc3LjAwNzgtMTQuNzctMTguOTg4IDE1LjIxLTE2Ljc3MnoiIGZpbGw9InVybCgjZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgTranstelekom as ReactComponent };